import { createStore as reduxCreateStore } from 'redux';

import createRootReducer from 'stash/reducers';
import createMiddleware from 'stash/middleware';
import { init } from 'stash/actions/init';
import { hydrateStateFromCookies } from './hydrate';

export const createStore = ({ analytics, history }) => {
	const store = reduxCreateStore(
		createRootReducer(history),
		hydrateStateFromCookies(),
		createMiddleware({ analytics, history })
	);

	store.dispatch(init());

	return store;
};
